import { useEffect, useState } from 'react'

import Calendar, { type CalendarProps } from 'react-calendar'
import 'react-calendar/dist/Calendar.css'

import { getDateTimeLocale } from 'lib/dayjs'
import './_inlineDatePicker.scss'
import { useUserProfile } from 'store'

interface IExtendedCalendarProps extends CalendarProps {
    scheduledPosts?: Array<{ scheduled: Date; type: string }> ; dotsColor: string
}

interface ITileWithDots {
    date: Date
    dots: string[]
}

export default function InlineDatePicker(
    props: IExtendedCalendarProps
): JSX.Element {
    const [tilesWithDots, setTilesWithDots] = useState<ITileWithDots[]>([])

    const userData = useUserProfile()!

    const langCode =
    typeof userData?.language === 'object' && userData?.language?.code
        ? String(userData.language.code).toLowerCase()
        : 'en'; // fallback

    const convertScheduledPostsToTilesWithDots = () => {
        const tiles: ITileWithDots[] = []

        props.scheduledPosts?.forEach(post => {
            if (post.scheduled) {
const newDate = new Date(post.scheduled)
newDate.setHours(0, 0, 0, 0)
                const existingTileIndex = tiles.findIndex(
                    tile => tile.date.getTime() === newDate.getTime()
                )

                if (existingTileIndex >= 0) {
                    // Boolean(
                    //     tiles[existingTileIndex].dots.length <= 5 &&
                    //         !tiles[existingTileIndex].dots.includes(post.type)
                    // ) && tiles[existingTileIndex].dots.push(post.type)
                    tiles[existingTileIndex].dots.push(post.type)
                } else {
                    tiles.push({
                        date: newDate,
                        dots: [post.type]
                    })
                }
            }
        })
        setTilesWithDots(tiles)
    }
    useEffect(() => {
        convertScheduledPostsToTilesWithDots()
    }, [props.scheduledPosts])

    const tileContent = ({
        date,
        view
    }: {
        date: Date
        view: 'month' | 'year' | 'decade' | 'century'
    }): JSX.Element | null => {
        if (view === 'month') {
            const tileIndex = tilesWithDots.findIndex(tile => {
const currentDate = new Date(date)
currentDate.setHours(0, 0, 0, 0)

const tileDate = new Date(tile.date)
tileDate.setHours(0, 0, 0, 0)

return tileDate.getTime() === currentDate.getTime()
            })
            if (tileIndex >= 0) {
                return (
                    <div className='dots-container'>
                        {tilesWithDots[tileIndex].dots.map((type, index) => (
                            <span key={index} className={`dot ${type}`}></span>
                        ))}
                    </div>
                )
            }
        }
        return <div className='dots-container'></div>
    }

    return (
        <Calendar
            tileContent={tileContent}
            minDate={new Date()}
            locale={getDateTimeLocale(langCode)}
            {...props}
        />
    )
}
